module.exports = __webpack_public_path__ + "static/media/technolingga.e998024e.png";